import { CustomAxiosHeaders } from '../config/services'
import config from '../config'
import { requests } from '.'
import firebase from 'firebase/compat/app'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'FormServices'
const host = config.formsApiUrl
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}
interface LocationIdParams {
  locationId: string
  limit: number
  skip?: number
  query?: string
}

interface GetById {
  id: string
}

interface UpdateForm {
  id: string
  name: string
  formData: object
}

interface CreateForm {
  parentId: string | undefined
  locationId: string
  formData?: object
}
interface FormsList {
  formIds: string
}

interface ExportSubmissionsParams {
  formIds: string[];
  startDate: string;
  endDate: string;
  locationId: string;
  companyId: string;
  type: string;
}

interface SubmissionsCountParams {
  locationId: string;
  startAt: string;
  endAt: string;
}

const FormServices = {
  getByLocationId: (params: LocationIdParams) =>
    request().get('/forms/', { params }),
  getCountByLocationId: (locationId: string) =>
    request().get('/forms/count', { params:{locationId} }),
  getById: (params: GetById) =>
    request().get(`/forms/${params.id}`),
  getListByIds:(params: FormsList) =>
    request().get(`/forms/forms-list`,{ params }),
  createForm: (params: CreateForm) =>
    request().post('/forms/', params),
  updateForm: (params: UpdateForm) =>
    request().post(`/forms/${params.id}`, {
      formData: params.formData,
      name: params.name,
    }),
  scheduleExportForm: (params: ExportSubmissionsParams) =>
    request().post('/forms/schedule-form-export', params),
  getSubmissionsCount: (params: SubmissionsCountParams) =>
    request().get('/forms/submissions-count', { params }),

  getByLocationIdV1: async (locationId: string, internalChannel) => {
    const firebaseToken = await firebase?.auth()?.currentUser?.getIdToken()
    const headers = {
      "location-id": locationId,
      "internal-channel": internalChannel,
      'token-id': firebaseToken,
    }
    return request({ headers, host: config.formsApiUrlV1, skipInterceptor: true}).get('/v1/forms')
  },
  getSubmissionById: (locationId: string, submissionId: string) =>
    request().get(`/forms/submission/${submissionId}`, { params: { locationId }}),
}

export { FormServices }
